module.exports = __webpack_public_path__ + "img/nikanor.4d65b7e4.jpg";